import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/articles";

export default function FeaturedPicks() {
  const featured = articles.find((item) => item.slug === "ditie-gongxiang-yusan-shiyan") ?? articles[5];
  const picks = articles.filter((item) => item.id !== featured.id).slice(0, 4);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-10 md:px-8 md:py-14">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.1fr_1fr]">
        <div>
          <h2 className="font-heading text-2xl tracking-wide text-foreground-950 md:text-3xl">编辑精选</h2>
          <p className="mt-2 text-sm text-foreground-600">不追热度，只挑值得慢慢读的那几篇。</p>

          <article className="group mt-6 overflow-hidden rounded-xl border border-background-200 bg-background-50">
            <Link to={`/article/${featured.id}`} className="relative block h-56 w-full overflow-hidden bg-background-200 md:h-72">
              <img
                src={featured.cover}
                alt={featured.title}
                title={`${featured.title} - ${featured.categoryName}`}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </Link>
            <div className="p-5 md:p-6">
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
                {featured.categoryName}
              </span>
              <Link to={`/article/${featured.id}`}>
                <h3 className="mt-3 font-heading text-xl leading-snug tracking-wide text-foreground-950 transition-colors group-hover:text-primary-600 md:text-2xl">
                  {featured.title}
                </h3>
              </Link>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{featured.excerpt}</p>
              <Link
                to={`/article/${featured.id}`}
                className="mt-5 inline-flex h-10 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                阅读全文
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </article>
        </div>

        <div>
          <div className="flex items-center justify-between border-b border-background-200 pb-3">
            <h3 className="flex items-center gap-2 font-heading text-xl tracking-wide text-foreground-950">
              <span className="flex h-6 w-6 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                <i className="ri-bookmark-3-line text-sm"></i>
              </span>
              值得一看
            </h3>
          </div>
          <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2">
            {picks.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}